import React, { FC, PropsWithChildren } from 'react'
import { Card, Stack } from 'design-system'

interface LinkWrapperProps extends PropsWithChildren {
  className?: string
}

export const ShareLinkWrapper: FC<LinkWrapperProps> = ({ children }) => {
  return (
    <Card className="mx-auto my-16 max-w-max p-8">
      <Stack gap={2} className="items-center justify-center text-center">
        {children}
      </Stack>
    </Card>
  )
}
